/**
 * Pure URL helpers for projects and work items. No DB access — safe
 * in the client bundle.
 *
 * Project URLs are rendered as `/<group-path>/<project-slug>/...`,
 * both pulled from the GitLab binding (`Project.group.path` and
 * `Project.slug` — the latter is overwritten by gitlab-sync to
 * mirror the GitLab project path). A project without a GitLab
 * counterpart (no group, no slug) cannot be rendered and the
 * helpers throw.
 *
 * Until the 2026-05-20 decouple, the URL prefix came off
 * `customer.gitlabGroupPath`. Customer is now Hub-only and the
 * group lives on the project directly.
 */

export type ProjectIdentity = {
  id: string;
  slug: string;
  group: { path: string } | null;
};

function assertGitlabPath(p: ProjectIdentity): asserts p is ProjectIdentity & {
  group: { path: string };
} {
  if (!p.slug || !p.group?.path) {
    throw new Error(
      `Project ${p.id} has no GitLab binding (project.slug + project.group.path) — URLs cannot be rendered.`,
    );
  }
}

export function projectHref(p: ProjectIdentity): string {
  assertGitlabPath(p);
  return `/${p.group.path}/${p.slug}`;
}

export function workItemHref(globalId: number): string {
  return `/work-item/${globalId}`;
}

export function projectSubHref(p: ProjectIdentity, segment: string): string {
  return `${projectHref(p)}/-/${segment}`;
}
